import { Typography } from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";
import { getGoBadgeStyles } from "./style";

interface GoBadgeProps {
    label: string;
    textColor: string;
    backgroundColor: string;
    borderColor: string;
    sx?: SxProps<Theme>;
}

const GoBadge = ({
    label,
    textColor,
    backgroundColor,
    borderColor,
    sx = {}
}: GoBadgeProps) => {
    const baseStyles = getGoBadgeStyles(textColor, backgroundColor, borderColor);

    return (
        <Typography
            variant="overline"
            sx={{ ...(baseStyles as object), ...(sx as object) }}
        >
            {label}
        </Typography>
    );
};

export default GoBadge;
